import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { MarketingShell } from "../components/MarketingShell";
import { getPublicSiteOrigin } from "../api/client";

export default function AboutPage() {
  const origin = getPublicSiteOrigin() || "https://setpilot.org";
  const url = `${origin}/about`;
  const title = "About SetPilot — DJ set planning assistant";
  const description =
    "SetPilot helps DJs sketch harmonic sets with BPM, Camelot key, and energy-aware ordering — you stay in control.";

  return (
    <MarketingShell>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>

      <article className="m-prose">
        <h1>About SetPilot</h1>
        <p className="m-lede">
          SetPilot is a <strong>harmonic mixing assistant</strong> and <strong>DJ set planner</strong> that runs in your
          browser. Upload your own tracks, get quick estimates for tempo and key, pick a vibe, and explore a suggested
          order with short transition ideas — then drag, tweak, and export when you are ready.
        </p>

        <h2>Who it is for</h2>
        <p>
          Bedroom and club DJs who already think about key and energy, but want a faster way to sketch a night without
          losing the human ear for what actually works on the floor.
        </p>

        <h2>How we think about the product</h2>
        <p>
          Suggestions, not autopilot: the tool proposes; you decide. Session-first design means you can try ideas without
          building a full account workflow first.
        </p>

        <h2>Beta</h2>
        <p>
          SetPilot is in active development. Features, limits, and retention may change. We appreciate{" "}
          <Link to="/contact">feedback</Link>.
        </p>

        <p style={{ marginTop: 28 }}>
          <Link to="/">Open the app →</Link>
        </p>
      </article>
    </MarketingShell>
  );
}
